import { ThemeList } from '../interfaces';
import { ThemeBase as base } from './base';

export const Themes: ThemeList = {
  base: { name: 'base', variables: base() },
};
